module.exports = __webpack_public_path__ + "static/img/30002 (3).beb0c58.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30002 (3).webp
// module id = iHup
// module chunks = 14